module.exports = __webpack_public_path__ + "img/qing.c429a85a.png";